// The login reads `?notice=` from the URL, so only these keys may select a
// message: nothing from the query string is ever rendered as text.
const LOGIN_NOTICE_I18N_KEYS: Record<string, string> = {
  'account-already-active': 'common.signIn.accountAlreadyActive'
};

export const getLoginNoticeI18nKey = (notice: unknown): string | undefined =>
  typeof notice === 'string' &&
  Object.prototype.hasOwnProperty.call(LOGIN_NOTICE_I18N_KEYS, notice)
    ? LOGIN_NOTICE_I18N_KEYS[notice]
    : undefined;
